import { Component } from 'react';
import { Flow } from 'flow-react';
import { observer } from "mobx-react"
import { Container, Row, Col} from 'react-bootstrap';
import './Userdata.css';


const Userdata = observer(
  class Userdata extends Component {
		
		state = {user:false};
		
		newuser = false;
	
		//mapping der Chains auf classnames, das wird in der reihenfolge durchgegangen 
		//"France 3 Régions","france_3_regions" ist hier auch drin
		chains = ["Réseau la 1ère","France 2","France 3 Régions","France 3","France 4","France 5","Outre-Mer la 1ère","france.tv distribution","francetv-la plateforme","Information","Jeunesse","Sport"];
		chacls = ["reseau_la_1ere","france_2","france_3","france_3","france_4","france_5","outre_mer_la_1ere","france_tv_distribution","france_tv_platform","information","jeunesse","sport"];
		//genres sind nur dazu da: wenn man ein genre in seinen stations hat, bekommt man immer alle chains
		genres = ["Sport","Jeunesse","Information"];


		stats = ["Guadeloupe","Guyane","La Réunion","Martinique","Mayotte","Nouvelle Calédonie","Polynésie","Saint-Pierre et Miquelon","Wallis et Futuna"]
		stcls = ["guadeloupe","guyane","la_reunion","martinique","mayotte","nouvelle_caledonie","polynesie","saint_pierre_et_miquelon","wallis_et_futuna"]
		
		constructor(props) {
			super(props);
			// Don't call this.setState() here!
			this.state = { user: props.user };
		}
	

		// componentDidMount = () => {
			// console.log('sessionget:')
			// this.props.flow.sessionGet()
				// .then(res=>{
					// console.log(res);
				// }).catch(e => {
						// console.log(e);
				// });
		// }

	
		deleteUser = c => {
			if(!window.confirm('Êtes vous sûr(e) de vouloir supprimer votre compte?'))
				return false;
				this.props.flow.ftvfeDeleteMe()
				.then(res=>{
						document.location.reload();
				}).catch(e => {
						console.log(e);
				});
		
		}
	
		getChClass = c => {
			return this.chacls[this.chains.indexOf(c)];
		}

		changeInput = evt => {
			if(this.newuser == false)
				this.newuser = {};
			this.newuser[evt.target.name] = evt.target.value;
		}

		saveUserdata = () => {
			if(this.newuser.newpass) {
				if(this.newuser.newpass.length < 8) 
					return '8 caractères minimum.';
				if(this.newuser.newpass != this.newuser.newpass2) 
					return 'Passwords do not mach';
			}
			
			this.props.flow.ftvfeUpdateUser(this.newuser)
				.then(res=>{
						alert("Vos informations ont bien été modifiées");
						this.props.updusercb(res.data);
						this.setState({mess:'updated'});
				}).catch(e => {
						console.log(e);
				});
		}

		registerChannels = () => {
			let channels = [];
			for (var el of document.getElementsByClassName('udacheck'))
				if (el.checked)
					channels.push(el.value);
			if(channels.length > 0)
				this.props.flow.ftvfeRequestChannels(channels).then(this.cbRegisterChannels);
		}
		
		cbRegisterChannels = (erg) => {
			this.props.updusercb(erg.data);
		}
		
    render() {
			let u = this.props.user;
			return  (
			<Container className="ovcont" fluid>
				<Row className="overlay">
					<Col className="ovcont" xs={12} >
						<Row><Col className="h50" xs={12} /></Row>
						<Row>
							<Col className="ovcont" />
							<Col className="ovcdiv" xs={12} md={6}>
								<Row>
									<Col className="ovheader" xs={10}></Col>
									<Col className="tar" xs={2}>
										<input className="btn_close" onClick={ this.props.closecb } type="submit" value="Fermer" />
									</Col>
								</Row>
								<Row>
									<Col className="ovheader" xs={12}>Mon compte</Col>
								</Row>
								<Row>
									<Col></Col>
									<Col className="ovlabel" xs={5}>Prénom:</Col>
									<Col className="ovinp" xs={6}>
										<input type="text" name="fname" className="ovinput" onChange={ this.changeInput } defaultValue={u.fname} />
									</Col>
								</Row>
								<Row>
									<Col></Col>
									<Col className="ovlabel" xs={5}>Nom:</Col>
									<Col className="ovinp" xs={6}>
										<input type="text" name="name" className="ovinput" onChange={ this.changeInput } defaultValue={u.name} />
									</Col>
								</Row>
								<Row>
									<Col></Col>
									<Col className="ovlabel" xs={5}>adresse e-mail:</Col>
									<Col className="ovinp" xs={6}>
										<input type="text" name="email" className="ovinput"  onChange={ this.changeInput } defaultValue={u.email} />
									</Col>
								</Row>
								<Row>
									<Col></Col>
									<Col className="ovlabel" xs={5}>Rubrique:</Col>
									<Col className="ovinp" xs={6}>
										<input type="text" name="company" className="ovinput" onChange={ this.changeInput } defaultValue={u.company} />
									</Col>
								</Row>
								<Row>
									<Col></Col>
									<Col className="ovlabel" xs={5}>Fonction:</Col>
									<Col className="ovinp" xs={6}>
										<input type="text" name="function" className="ovinput" onChange={ this.changeInput } defaultValue={u.function} />
									</Col>
								</Row>
								<Row>
									<Col></Col>
									<Col className="ovlabel" xs={5}>Média:</Col>
									<Col className="ovinp" xs={6}>
										<input type="text" name="area" className="ovinput" onChange={ this.changeInput } defaultValue={u.area} />
									</Col>
								</Row>
								<Row>
									<Col className="ovheadersm" xs={12}>Modifier mon mot de passe</Col>
								</Row>
								<Row>
									<Col></Col>
									<Col className="ovlabel" xs={5}>Mot de passe:</Col>
									<Col className="ovinp" xs={6}>
										<input type="password" name="newpass" autoComplete="new-password" defaultValue="" className="ovinput" onChange={ this.changeInput }  />
									</Col>
								</Row>
								<Row>
									<Col></Col>
									<Col className="ovlabel" xs={5}>Confirmez le mot de passe:</Col>
									<Col className="ovinp" xs={6}>
										<input type="password" name="newpass2" autoComplete="new-password" defaultValue="" className="ovinput" onChange={ this.changeInput } />
									</Col>
								</Row>
								<Row>
									<Col className="tar" xs={11}>
										<input className="btn_ok" onClick={ this.saveUserdata } type="submit" value="Enregistrer les modifications" />
									</Col>	
								</Row>
								<Row>
									<Col className="tar mt10" xs={11}>
										<input className="btn_delme" onClick={ this.deleteUser } type="submit" value="Supprimer mon compte" />
									</Col>	
								</Row>
								
								<Row>
									<Col className="ovheadersm" xs={12}>Mes accréditations</Col>
								</Row>
								{this.chains.map(c => {//erlaubte Channels: es gibt immer mindestens einen
									if(u.stations.indexOf(c) > -1) 
									return (<Row key={this.chains.indexOf(c)}>
														<Col></Col>
														<Col className="udachiconcol" xs={11}>
															<div className={'udachicon  uda_'+this.getChClass(c)}>{c}</div>
														</Col>
													</Row>)
								})}
								{//angefragte channels, nur wenn es auch einen oder mehr gibt
									u.regstations.length > 0 && <>
								
								<Row>
									<Col className="ovheadersm" xs={12}>Mes demandes d'accréditation en cours de validation</Col>
								</Row>
								{this.chains.map(c => {
									if(u.regstations.indexOf(c) > -1) 
									return (<Row key={this.chains.indexOf(c)}>
														<Col></Col>
														<Col className="udachiconcol" xs={11}>
															<div className={'udachicon  uda_'+this.getChClass(c)}>{c}</div>
														</Col>
													</Row>)
								})}
								</>}
								
								{//channels, die man anfragen koennte: nur wenn nicht alle in regstations oder stations sind 
									u.regstations.length + u.stations.length <  (this.chains.length) && <>
									<Row>
										<Col className="ovheadersm" xs={12}>Nouvelles demandes d'accréditation</Col>
									</Row>
									{this.chains.map(c => {
										if(u.regstations.indexOf(c) < 0 && u.stations.indexOf(c) < 0) 
										return (<Row key={this.chains.indexOf(c)}>
															<Col></Col>
															<Col className="udachiconcol" xs={11}>
																<input className="udacheck" type="checkbox" value={c} />
																<div className={'udachicon  uda_'+this.getChClass(c)}>{c}</div>
															</Col>
														</Row>)
									})}
								
								<Row>
									<Col className="tar" xs={11}>
										<input className="btn_ok" onClick={ this.registerChannels } type="submit" value="Envoyer" />
									</Col>	
								</Row></>}
								
								<Row><Col className="h50" xs={12} /></Row>
							</Col>
							<Col className="ovcont" />
						</Row>
						<Row><Col className="h50 ovcont" xs={12} /></Row>
					</Col>
					

				</Row>
				</Container>

			)
    }
		
  }
)


export default Flow.injectFlow(Userdata);